export enum AquatecSystemApiEnum {
    AQUATEC_API = 'AQUATEC_API'
}